function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "referral");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M872.7484,765.28719l-229.21475.75921c-60.81042-18.2721-110.63231-81.736-110.94745-176.88721a269.465,269.465,0,0,1,3.23811-42.81223l184.62183-41.47768,142.42432-31.995a283.26116,283.26116,0,0,1,29.25631,30.4193l-136.19064,71.9123L691.689,609.13206l72.19443-24.90689,149.84346-51.69429a363.36982,363.36982,0,0,1,24.91621,44.67248L893.432,623.9282l51.14434-33.48237q.32789.76935.653,1.54117C977.64276,668.937,937.42608,765.073,872.7484,765.28719Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#f2f2f2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M835.07951,451.33807c-34.66293,9.9552-77.27874,22.53336-121.09466,35.60691-63.35145,18.90781-129.20892,38.86137-177.15524,53.44709l.0313-.171a65.899,65.899,0,0,1,12.15994-28.22451c35.51715-46.17886,80.74258-78.4385,131.07658-90.4187h.00442a188.90679,188.90679,0,0,1,43.20152-5.15431C763.34926,416.29093,801.28113,428.85107,835.07951,451.33807Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#f2f2f2"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 360.21666,
  cy: 710.53603,
  rx: 228,
  ry: 17,
  fill: "#3f3d56"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M569.53293,488.16005c0,122.83942-73.02608,165.73036-163.10833,165.73036S243.31627,610.99947,243.31627,488.16005,406.4246,209.0495,406.4246,209.0495,569.53293,365.32062,569.53293,488.16005Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#f2f2f2"
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  points: "157.167 575.737 158.837 472.932 228.358 345.747 159.099 456.805 159.85 410.579 207.763 318.562 160.048 398.346 160.048 398.347 161.399 315.208 212.706 241.951 161.611 302.134 162.455 149.687 157.152 351.5 157.588 343.174 105.424 263.329 156.751 359.156 151.891 452.008 151.746 449.543 91.61 365.517 151.564 458.25 150.956 469.862 150.847 470.036 150.897 470.99 138.566 706.562 155.041 706.562 157.018 584.884 216.825 492.38 157.167 575.737",
  fill: "#3f3d56"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M764.21951,88.49224V736.69219a29.13911,29.13911,0,0,1-29.13,29.11005h-263.15a29.0791,29.0791,0,0,1-29.13-29.11V88.49224a29.12749,29.12749,0,0,1,29.13-29.13h39.38v5.05a23.987,23.987,0,0,0,23.98,23.99h133.84a23.78923,23.78923,0,0,0,14.22-4.68,22.28455,22.28455,0,0,0,2.36-1.98,23.917,23.917,0,0,0,7.4-17.33v-5.05h41.97A29.12108,29.12108,0,0,1,764.21951,88.49224Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#3f3d56"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M591.54274,313.16278c.00878,18.08931-10.74208,24.4098-24.00649,24.41624q-.46216.00022-.91988-.00987-.92212-.01944-1.825-.08314c-11.972-.84182-21.27711-7.47688-21.28528-24.2999-.00846-17.40973,22.23173-39.39129,23.89967-41.01662l.00293-.00148c.06337-.06194.0958-.09291.0958-.09291S591.534,295.07494,591.54274,313.16278Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#40a9ff"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M566.66072,334.81246l8.77851-12.27805-8.8,13.62544-.02289,1.4093q-.92212-.01944-1.825-.08314l.93762-18.09715-.00743-.14.01618-.02655.08911-1.71006-8.83533-13.65078,8.86123,12.36973.0223.36264.70832-13.67311-7.56483-14.10691,7.65653,11.704.73069-28.3483.00289-.09434,0,.09286-.11295,22.35557,7.51828-8.86625-7.54979,10.79151-.19306,12.24293,7.02156-11.7524L567.044,310.49172l-.10725,6.80769L577.127,300.94022l-10.22888,18.73406Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#3f3d56"
});

var _ref11 = /*#__PURE__*/React.createElement("polygon", {
  points: "474.198 484.701 246.198 484.701 246.198 506.979 246.198 540.906 246.198 559.994 265.287 540.906 474.198 540.906 474.198 484.701",
  fill: "#40a9ff"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 297.06492,
  y: 498.34775,
  width: 128.26667,
  height: 10.4,
  fill: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 297.06492,
  y: 513.94775,
  width: 128.26667,
  height: 10.4,
  fill: "#fff"
});

var _ref14 = /*#__PURE__*/React.createElement("polygon", {
  points: "246.198 382.201 474.198 382.201 474.198 404.479 474.198 438.406 474.198 457.494 455.11 438.406 246.198 438.406 246.198 382.201",
  fill: "#40a9ff"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 285.06492,
  y: 396.84775,
  width: 128.26667,
  height: 10.4,
  fill: "#fff"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 285.06492,
  y: 412.44775,
  width: 128.26667,
  height: 10.4,
  fill: "#fff"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M480.51452,205.808V389.39992h246V205.808Zm31.69933,2.31141a3.96242,3.96242,0,1,1-3.96242,3.96241A3.9624,3.9624,0,0,1,512.21385,208.11939Zm-23.7745,7.92483a3.96242,3.96242,0,1,1,3.96242-3.96242A3.96242,3.96242,0,0,1,488.43935,216.04422Zm7.92484-3.96242a3.96242,3.96242,0,1,1,3.96241,3.96242A3.9624,3.9624,0,0,1,496.36419,212.0818ZM632.73734,337.88851H500.3266v-98.4H632.73734Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#f2f2f2"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 469.9902,
  y: 149.74776,
  width: 7.92483,
  height: 0.9906,
  fill: "#fff"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 469.9902,
  y: 152.71957,
  width: 7.92483,
  height: 0.9906,
  fill: "#fff"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 469.9902,
  y: 155.69138,
  width: 7.92483,
  height: 0.9906,
  fill: "#fff"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 410.22375,
  y: 178.47527,
  width: 59.76644,
  height: 2.97181,
  fill: "#fff"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 410.22375,
  y: 188.71151,
  width: 59.76644,
  height: 2.97181,
  fill: "#fff"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  x: 410.22375,
  y: 198.94776,
  width: 59.76644,
  height: 2.97181,
  fill: "#fff"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  x: 410.22375,
  y: 209.184,
  width: 59.76644,
  height: 2.97181,
  fill: "#fff"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 410.22375,
  y: 219.42024,
  width: 59.76644,
  height: 2.97181,
  fill: "#fff"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  x: 410.22375,
  y: 229.65648,
  width: 59.76644,
  height: 2.97181,
  fill: "#fff"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  x: 410.22375,
  y: 239.89272,
  width: 59.76644,
  height: 2.97181,
  fill: "#fff"
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  x: 410.22375,
  y: 250.12896,
  width: 59.76644,
  height: 2.97181,
  fill: "#fff"
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  x: 410.22375,
  y: 260.36521,
  width: 59.76644,
  height: 2.97181,
  fill: "#fff"
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  x: 410.22375,
  y: 270.60145,
  width: 59.76644,
  height: 2.97181,
  fill: "#fff"
});

var _ref31 = /*#__PURE__*/React.createElement("circle", {
  cx: 264.93516,
  cy: 285.46051,
  r: 3.96242,
  fill: "#fff"
});

var _ref32 = /*#__PURE__*/React.createElement("circle", {
  cx: 278.47342,
  cy: 285.46051,
  r: 3.96242,
  fill: "#fff"
});

var _ref33 = /*#__PURE__*/React.createElement("circle", {
  cx: 292.01167,
  cy: 285.46051,
  r: 3.96242,
  fill: "#fff"
});

var _ref34 = /*#__PURE__*/React.createElement("rect", {
  x: 410.22375,
  y: 304.94239,
  width: 59.76644,
  height: 16.84027,
  fill: "#40a9ff"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M388.223,594.88228l-2.19087,76.6803-23.36924,89.8255s5.112,15.33606,1.46058,18.98751-20.44808,10.224-20.44808,10.224L357.55086,599.264Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#2f2e41"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M337.48626,780.00137s-8.33383,18.33442,3.33353,20.00119,65.55945,6.11147,62.22592-3.33353-43.8915-18.33443-43.8915-18.33443Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#2f2e41"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M306.43066,526.96544s8.76346,47.46876,14.60577,55.50193-2.92115,66.45627-2.92115,66.45627-13.1452,83.98319-7.30289,97.12838,4.38173,8.76346,3.65145,16.06635-2.19087,13.1452,0,19.71779,2.19086,5.84231,2.92115,9.49376,0,23.36923,0,23.36923,31.40241,10.95433,36.51443-5.112c0,0-7.30289-10.224-5.112-18.25721a97.25834,97.25834,0,0,0,3.65144-24.82982V751.164L386.03212,625.5544l8.03317-45.27789s-2.19086-46.00819-10.224-50.38992S306.43066,526.96544,306.43066,526.96544Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#2f2e41"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M319.57586,811.04771s-10.95433,24.09952,4.38173,26.29039,86.17405,8.03317,81.79232-4.38173-57.6928-24.09953-57.6928-24.09953Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#2f2e41"
});

var _ref39 = /*#__PURE__*/React.createElement("circle", {
  cx: 90.14269,
  cy: 228.09901,
  r: 29.21154,
  fill: "#ffb9b9"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M312.93194,300.36971l.54379,37.30514,35.81374.12127s-9.08919-29.20329-5.018-35.30993S312.93194,300.36971,312.93194,300.36971Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#ffb9b9"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M366.31433,358.26877s-25.5601-32.863-45.2779-18.98751-27.02068,46.73847-27.02068,46.73847l4.38174,92.01637s10.95433,13.14519,4.38173,21.90866-10.224,6.57259-5.112,13.14519,10.95433,11.68462,8.76346,13.87549,2.19087,3.65144,2.19087,3.65144l77.41059,2.19086s-2.19087-2.92115,4.38173-11.68461-1.46058-20.44808,0-24.82982,2.92116.73029,3.65144-9.49375S366.31433,358.26877,366.31433,358.26877Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#3f3d56"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M359.01144,546.68323s1.46058,18.25721,12.41491,21.17837c4.10787,1.09543,7.18878-.99274,9.43527-4.03085a17.93477,17.93477,0,0,0,.57336-20.12122l-2.70575-4.32919Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#ffb9b9"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M291.45974,321.38919s-.73028,14.60577,0,16.79664,1.46058,4.38173,0,6.5726-.73028,9.49375.73029,10.224-2.92115,7.30288-1.46057,11.68461,2.92115,5.84231,3.65144,7.30289,1.9067,4.07742,1.9067,4.07742,21.46253-45.70387,38.98946-34.74954,31.40241,14.60577,31.40241,14.60577S357.18572,306.78342,291.45974,321.38919Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#3f3d56"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M323.2273,355.34761s-23.36924,2.19087-21.90866,32.863-2.19087,78.87117-2.19087,78.87117,40.16588,61.34424,46.73848,65.726,7.30288,3.65145,6.57259,7.30289-1.46057,6.5726,1.46058,9.49375a25.21718,25.21718,0,0,0,5.84231,4.38173s23.36924-8.03317,21.17837-15.33606-12.41491-18.9875-12.41491-18.9875-17.52692-28.48126-18.25721-32.863-.73029-3.65144-2.92116-5.84231-8.03317-10.95433-8.03317-15.33606V451.74571l6.12255-74.15089a21.49637,21.49637,0,0,0-5.70094-16.64789C336.23967,357.31072,330.98662,354.41649,323.2273,355.34761Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#3f3d56"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M352.29754,264.93387a11.90283,11.90283,0,0,0,11.02985-2.52548c2.85465-2.71251,3.81414-7.41226,1.78294-10.78584-1.754-2.91319-5.16532-4.33793-8.41146-5.35075a74.47,74.47,0,0,0-22.11723-3.37354c-3.57572-.001-7.30946.30371-10.36931,2.15387-1.514.91545-2.79626,2.17272-4.29312,3.11595-2.75234,1.73437-6.0573,2.31071-9.07918,3.51556a23.29009,23.29009,0,0,0-13.27324,14.05621,28.06457,28.06457,0,0,0-1.29,6.60225,36.17506,36.17506,0,0,0,3.15616,17.93107c4.07486,8.88513,11.8305,16.356,12.92634,26.06932,4.17488-3.50467,5.39865-9.38339,8.63233-13.77152a17.85552,17.85552,0,0,1,9.74781-6.61632,5.676,5.676,0,0,0,2.95185-1.31946,4.89045,4.89045,0,0,0,.92374-2.66007l2.00431-14.43131c.4079-2.937.95892-6.14658,3.21269-8.07341a11.42324,11.42324,0,0,1,4.78558-2.07675,77.18486,77.18486,0,0,1,12.492-2.037",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#2f2e41"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M302.67959,477.51374l40.99579,53.201S305.92641,499.1592,302.67959,477.51374Z",
  transform: "translate(-243.31627 -59.36223)",
  opacity: 0.1
});

var _ref47 = /*#__PURE__*/React.createElement("polygon", {
  points: "98.713 359.249 98.325 409.493 122.135 445.208 102.654 405.164 98.713 359.249",
  opacity: 0.1
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M785.10425,751.623l-4.74473-3.525s-3.14071,17.54355.36393,20.172,16.647,7.00928,16.647,12.26624,29.78945,12.26625,30.66561,4.3808-2.62848-12.26624-2.62848-12.26624-14.01857-14.01856-15.77089-16.647-6.13312-7.88544-6.13312-7.88544Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#2f2e41"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M855.19706,533.45913s-.13144.771-.35915,2.18163c-.21037,1.25291-.49947,3.02277-.84995,5.2044-3.67994,22.456-14.4129,88.56228-13.68562,90.74391.87616,2.62848,7.00928,12.26625,0,14.89473a5.43517,5.43517,0,0,0-2.18163,2.37436,50.924,50.924,0,0,0-3.70614,8.74411c-4.1793,12.126-8.64781,31.533-11.23244,44.97326-1.13028,5.90537-1.90119,10.65414-2.129,13.14241a7.1456,7.1456,0,0,0-.02632,1.73483c.87617,3.50464-5.257,15.77088-7.88544,19.27552s-7.00928,7.00929-6.13312,10.51393-21.904,13.1424-24.53248,7.00928-2.62848-9.63776-3.50464-11.39008-1.75232-14.01857,2.62848-15.77089,1.75232-32.41792,6.13312-38.551c1.46312-2.04147,3.69737-8.95439,6.03675-17.26914.91991-3.25929,1.84869-6.72891,2.75993-10.20724,3.69737-14.25514,6.9742-28.59788,6.9742-28.59788l-.87616-102.51074,48.18881-6.13312,1.23531,2.72485,2.46206,5.40589Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#2f2e41"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M857.82554,701.68189s7.00928-7.00928,10.51392,0,7.00929,34.17024,13.14241,40.30337,14.01856,36.79872,5.257,38.551-18.39937-2.62848-19.27553-7.88544-19.27552-32.41792-19.27552-35.04641S860.454,725.33821,860.454,725.33821Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#2f2e41"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M750.05784,485.27032s11.39008,102.51074,14.01856,112.14851,16.647,46.43649,21.02785,52.56961,32.41792,56.07425,35.92256,58.70273,10.51393,9.63776,10.51393,9.63776,13.1424,13.1424,14.89472,15.77088,16.647-5.257,17.5232-10.51392-.87616-14.01856-1.75232-17.5232,1.75232-8.7616-.87616-11.39008-15.77088-15.77089-15.77088-21.904-22.78016-42.05569-31.54177-49.94113-7.00928-21.02784-7.00928-21.02784V548.35386l48.18881-14.89473s-2.62848-42.05568-8.7616-42.05568S759.6956,477.38488,750.05784,485.27032Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#2f2e41"
});

var _ref52 = /*#__PURE__*/React.createElement("circle", {
  cx: 577.71054,
  cy: 250.67605,
  r: 28.91329,
  fill: "#9f616a"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M811.38905,332.81845s-3.50464,13.14241-7.88544,16.64705,11.39008,18.39936,11.39008,18.39936l29.78945,1.75232,5.257-16.647s-9.63776-19.27553-7.00928-31.54177S811.38905,332.81845,811.38905,332.81845Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#9f616a"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M799.12281,347.71318s7.88544.87616,9.63776,3.50464,14.01857,10.51392,23.65633,8.7616,15.77088-4.3808,17.5232-3.50464,5.257,19.27552,5.257,19.27552l-9.63776,28.03713,1.75232,77.10209,2.62848,21.02785s5.257-7.00928-15.77088-2.62848-48.18881-3.50464-56.95041-4.3808-23.65633-3.50464-24.53249-8.76161S755.3148,461.614,755.3148,461.614l14.01856-58.70273L778.095,371.3695Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#3f3d56"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M807.41032,343.75871s-7.41135-3.931-10.03983-.42633-35.92257,8.7616-35.92257,11.39008-7.00928,73.59745-5.257,79.73057-3.50464,13.14241-3.50464,13.14241l-6.13312,26.2848s-16.647,49.94113-9.63776,51.69345,13.1424,0,15.77088,0,1.75232-33.29408,8.7616-42.05569,16.64705-30.6656,18.39937-35.0464,23.65632-64.83586,22.78016-71.84514S807.41032,343.75871,807.41032,343.75871Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#d0cde1"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M843.807,347.71318s7.00928,0,7.88544,1.75232,9.63776,13.1424,13.1424,15.77088,15.77089,14.01856,15.77089,16.647-25.40865,21.904-25.40865,21.904-10.51392,51.69345-5.257,69.21665,13.1424,59.57889,9.63776,62.20737-11.39008,3.50464-11.39008,0-5.257-41.17952-9.63776-49.065-17.52321-57.82657-12.26624-71.84513S843.807,347.71318,843.807,347.71318Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#d0cde1"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M728.15384,434.453s-.87616,27.161,8.7616,41.17953A166.5054,166.5054,0,0,1,752.68632,505.422s15.77088-4.3808,18.39936-9.63776,19.27553-.87616,19.27553-2.62848-20.15169-10.51393-21.904-12.26625-7.88544-1.75232-11.39008-5.257-4.3808-11.39008-4.3808-11.39008l-3.50464-22.78016Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#9f616a"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M801.11287,292.211a16.6624,16.6624,0,0,1-6.48423-1.48454c-4.4048-2.37548-5.57284-9.14023-2.21967-12.85525a16.61293,16.61293,0,0,1,3.08032-2.47684l6.66-4.53311c2.94555-2.0049,5.96073-4.04265,9.39622-4.98779a29.33183,29.33183,0,0,1,9.60574-.56707A64.90619,64.90619,0,0,1,839.5513,268.652c5.87305,2.15589,11.35157,5.76262,14.90856,10.90931,5.63894,8.15907,5.71644,19.163,2.61069,28.5823s-9.00529,17.62147-14.81834,25.65743l-3.01623-14.717c-.26865-1.31082-.61607-2.74747-1.70628-3.52326-2.70964-1.92819-6.02416,2.03077-9.34973,2.0051-2.13681-.01649-3.93081-1.774-4.7406-3.75152a21.37921,21.37921,0,0,1-1.05046-6.29606c-.39683-4.50861-1.97271-10.782-6.24239-13.2685C812.16787,291.93277,805.585,292.61718,801.11287,292.211Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#2f2e41"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M802.73482,534.16627s2.95919,85.59464,4.71151,88.22312,0-88.49218,0-88.49218Z",
  transform: "translate(-243.31627 -59.36223)",
  opacity: 0.1
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M768.4572,354.72246h-7.00928s-29.78944,40.30337-26.2848,42.93185,0,9.63776,0,9.63776l-7.00928,13.1424s-8.76161,7.88544-6.13313,9.63776,6.13313,8.7616,6.13313,8.7616,17.5232-2.62848,22.78016,7.88545l11.36363-14.34589Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#d0cde1"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M848.18778,430.07223s-19.27552.87616-41.17953-13.1424l-21.904-9.63776s-19.27553-29.78945-21.02785-24.53249,2.62848,15.77089,2.62848,15.77089S738,404,739.58348,412.38122c.32617,1.72636,14.85516-2.46067,14.85516-2.46067s-2.62848,16.647,12.26624,17.5232,19.27553-2.62848,19.27553-2.62848,63.08353,52.56961,73.59745,35.92257S848.18778,430.07223,848.18778,430.07223Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#9f616a"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M870.968,378.37878l9.63776,3.50464v26.28481l3.50464,5.257s-.87616,10.51392-3.50464,13.1424-7.88544,1.75232-6.13312,7.88544a33.209,33.209,0,0,1,.87616,12.26625s-15.77089,20.15168-16.64705,17.5232-13.1424-35.04641-14.89472-35.04641,17.5232-50.81729,17.5232-50.81729Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#d0cde1"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M755.75288,511.11705s-9.05931-8.7616-4.52965-9.19968,20.30053-9.19968,22.929-4.81888S755.75288,511.11705,755.75288,511.11705Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#2f2e41"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M454.00625,744.00941c0,22.46856-13.35644,30.31375-29.83387,30.31375q-.57256,0-1.14332-.01273c-.76345-.01636-1.51961-.05271-2.26669-.10361-14.87057-1.05244-26.42387-9.30115-26.42387-30.19741,0-21.62514,27.63447-48.91242,29.71026-50.93189l.00364-.00363c.08-.07816.12-.11633.12-.11633S454.00625,721.54085,454.00625,744.00941Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#40a9ff"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M423.0854,770.88588,433.997,755.63905,423.05813,772.56l-.02907,1.75044c-.76345-.01636-1.51961-.05271-2.26669-.10361l1.17607-22.47946-.0091-.17451.02-.03271.11087-2.12307L411.094,732.43431l11.00071,15.37045.02547.45079.88884-16.98456-9.38839-17.52807,9.5029,14.547.9252-35.21244.00364-.12v.11633l-.1545,27.76715,9.34661-11.008-9.38477,13.40006L423.61253,738.44l8.72677-14.59429-8.76311,16.83189-.13815,8.4541,12.66935-20.31277-12.71661,23.2629Z",
  transform: "translate(-243.31627 -59.36223)",
  fill: "#3f3d56"
});

var SvgRefer = function SvgRefer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b3476446-c29b-489b-91f9-6dd64a8ef5f6",
    "data-name": "Layer 1",
    width: 250,
    height: 200,
    viewBox: "0 0 713.36746 781.27553",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRefer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/refer.297ec246.svg";
export { ForwardRef as ReactComponent };